"use client"

import React from "react";
import Image from "next/image";
import Tilt from "react-parallax-tilt";
import { FormattedMessage, useIntl } from "react-intl";

import useCaseOne from "@/assets/images/media/use-case-one.png"
import useCaseTwo from "@/assets/images/media/use-case-two.png"
import useCaseTree from "@/assets/images/media/use-case-tree.png"
import useCaseFour from "@/assets/images/media/use-case-four.png"

import useCaseOneIcon from "@/assets/images/media/use-case-one-icon.png"
import useCaseTwoIcon from "@/assets/images/media/use-case-two-icon.png"
import useCaseTreeIcon from "@/assets/images/media/use-case-tree-icon.png"
import useCaseFourIcon from "@/assets/images/media/use-case-four-icon.png"

const UseCases = () => {
  const intl = useIntl();

  return (
    <section id="use-cases" className="relative pt-[150px]">
      <div className="container lg:max-w-[1120px]">
        <div className="flex flex-wrap items-center justify-between -mx-4">
          <div className="w-full px-4 lg:w-1/2">
            <div className="wow fadeInUp relative z-10 mx-auto mb-14 w-full max-w-[470px] pb-6 lg:mx-0 lg:mb-0" data-wow-delay=".2s">
              <Tilt>
                <Image
                  src={useCaseOne}
                  width={300}
                  height={600}
                  alt="Influencers Downfor Profile"
                  title="Influencers Downfor Profile"
                  className="max-w-full mx-auto"
                />
              </Tilt>
              <div className="absolute bottom-20 left-0 z-10">
                <Image
                  src={useCaseOneIcon}
                  width={150}
                  height={150}
                  alt="Influencers Downfor Profile Emoji"
                  title="Influencers Downfor Profile Emoji"
                />
              </div>
              <div className="absolute bottom-0 left-0 -z-10 h-1/2 w-full rounded-[20px] bg-gradient-1"></div>
            </div>
          </div>

          <div className="w-full px-4 lg:w-1/2">
            <div className="wow fadeInUp lg:ml-auto lg:max-w-[510px]" data-wow-delay=".3s">
              <span className="mb-4 block text-lg font-medium text-primary md:text-[22px]">
                <FormattedMessage
                  id="home-page-use-case-one-sub-title"
                />
              </span>
              <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
                <FormattedMessage
                  id="home-page-use-case-one-title"
                />
              </h2>
              <p className="mb-[30px] text-base leading-relaxed text-body">
                <FormattedMessage
                  id="home-page-use-case-one-body-text"
                />
              </p>

              {intl.messages["home-page-use-case-one-headlines"]?.map((item, index) => (
                <div
                  key={index}
                  className="mb-[30px] flex items-center"
                >
                  <div
                    className="mr-[22px] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-stroke text-xl font-semibold text-black dark:border-stroke-dark dark:bg-dark dark:text-white"
                  >
                    {index + 1}
                  </div>
                  <div>
                    <h3 className="text-xl font-medium text-black dark:text-white">
                      {item?.title}
                    </h3>
                    <p className="text-base text-body">
                      {item?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-[100px]">
          <div className="flex flex-wrap items-center justify-between -mx-4">
            <div className="w-full px-4 lg:w-1/2">
              <div className="wow fadeInUp lg:max-w-[510px]" data-wow-delay=".2s">
                <span className="mb-4 block text-lg font-medium text-primary md:text-[22px]">
                  <FormattedMessage
                    id="home-page-use-case-two-sub-title"
                  />
                </span>
                <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
                  <FormattedMessage
                    id="home-page-use-case-two-title"
                  />
                </h2>
                <p className="mb-[30px] text-base leading-relaxed text-body">

                  <FormattedMessage
                    id="home-page-use-case-two-body-text"
                  />
                </p>

                {intl.messages["home-page-use-case-two-headlines"]?.map((item, index) => (
                  <div
                    key={index}
                    className="mb-[30px] flex items-center"
                  >
                    <div
                      className="mr-[22px] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-stroke text-xl font-semibold text-black dark:border-stroke-dark dark:bg-dark dark:text-white"
                    >
                      {index + 1}
                    </div>
                    <div>
                      <h3 className="text-xl font-medium text-black dark:text-white">
                        {item?.title}
                      </h3>
                      <p className="text-base text-body">
                        {item?.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="order-first w-full px-4 lg:order-last lg:w-1/2">
              <div className="wow fadeInUp relative z-10 mx-auto mb-14 w-full max-w-[470px] pb-6 lg:mr-0 lg:mb-0" data-wow-delay=".3s">
                <Tilt>
                  <Image
                    src={useCaseTwo}
                    width={300}
                    height={600}
                    alt="Festival Downfor Profile"
                    title="Festival Downfor Profile"
                    className="max-w-full mx-auto"
                  />
                </Tilt>
                <div className="absolute bottom-20 right-0 z-10">
                  <Image
                    src={useCaseTwoIcon}
                    width={150}
                    height={150}
                    alt="Festival Downfor Profile Emoji"
                    title="Festival Downfor Profile Emoji"
                  />
                </div>
                <div className="absolute bottom-0 left-0 -z-10 h-1/2 w-full rounded-[20px] bg-gradient-2"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between pt-[100px]">
          <div className="w-full px-4 lg:w-1/2">
            <div className="wow fadeInUp relative z-10 mx-auto mb-14 w-full max-w-[470px] pb-6 lg:mx-0 lg:mb-0" data-wow-delay=".2s">
              <Tilt>
                <Image
                  src={useCaseTree}
                  width={300}
                  height={600}
                  className="max-w-full mx-auto"
                  alt="Entrepreneur Downfor Profile"
                  title="Entrepreneur Downfor Profile"
                />
              </Tilt>
              <div className="absolute bottom-20 left-0 z-10">
                <Image
                  src={useCaseTreeIcon}
                  width={150}
                  height={150}
                  alt="Entrepreneur Downfor Profile Emoji"
                  title="Entrepreneur Downfor Profile Emoji"
                />
              </div>
              <div className="absolute bottom-0 left-0 -z-10 h-1/2 w-full rounded-[20px] bg-gradient-1"></div>
            </div>
          </div>

          <div className="w-full px-4 lg:w-1/2">
            <div className="wow fadeInUp lg:ml-auto lg:max-w-[510px]" data-wow-delay=".3s">
              <span className="mb-4 block text-lg font-medium text-primary md:text-[22px]">
                <FormattedMessage
                  id="home-page-use-case-tree-sub-title"
                />
              </span>
              <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
                <FormattedMessage
                  id="home-page-use-case-tree-title"
                />
              </h2>
              <p className="mb-[30px] text-base leading-relaxed text-body">
                <FormattedMessage
                  id="home-page-use-case-tree-body-text"
                />
              </p>

              {intl.messages["home-page-use-case-tree-headlines"]?.map((item, index) => (
                <div
                  key={index}
                  className="mb-[30px] flex items-center"
                >
                  <div
                    className="mr-[22px] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-stroke text-xl font-semibold text-black dark:border-stroke-dark dark:bg-dark dark:text-white"
                  >
                    {index + 1}
                  </div>
                  <div>
                    <h3 className="text-xl font-medium text-black dark:text-white">
                      {item?.title}
                    </h3>
                    <p className="text-base text-body">
                      {item?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="pt-[100px]">
          <div className="flex flex-wrap items-center justify-between -mx-4">
            <div className="w-full px-4 lg:w-1/2">
              <div className="wow fadeInUp lg:max-w-[510px]" data-wow-delay=".2s">
                <span className="mb-4 block text-lg font-medium text-primary md:text-[22px]">
                  <FormattedMessage
                    id="home-page-use-case-four-sub-title"
                  />
                </span>
                <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
                  <FormattedMessage
                    id="home-page-use-case-four-title"
                  />
                </h2>
                <p className="mb-[30px] text-base leading-relaxed text-body">

                  <FormattedMessage
                    id="home-page-use-case-four-body-text"
                  />
                </p>

                {intl.messages["home-page-use-case-four-headlines"]?.map((item, index) => (
                  <div
                    key={index}
                    className="mb-[30px] flex items-center"
                  >
                    <div
                      className="mr-[22px] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-stroke text-xl font-semibold text-black dark:border-stroke-dark dark:bg-dark dark:text-white"
                    >
                      {index + 1}
                    </div>
                    <div>
                      <h3 className="text-xl font-medium text-black dark:text-white">
                        {item?.title}
                      </h3>
                      <p className="text-base text-body">
                        {item?.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="order-first w-full px-4 lg:order-last lg:w-1/2">
              <div className="wow fadeInUp relative z-10 mx-auto mb-14 w-full max-w-[470px] pb-6 lg:mr-0 lg:mb-0" data-wow-delay=".3s">
                <Tilt>
                  <Image
                    src={useCaseFour}
                    width={300}
                    height={600}
                    alt="Band Downfor Profile"
                    title="Band Downfor Profile"
                    className="max-w-full mx-auto"
                  />
                </Tilt>
                <div className="absolute bottom-10 right-0 z-10">
                  <Image
                    src={useCaseFourIcon}
                    width={200}
                    height={200}
                    alt="Band Downfor Profile"
                    title="Band Downfor Profile"
                  />
                </div>
                <div className="absolute bottom-0 left-0 -z-10 h-1/2 w-full rounded-[20px] bg-gradient-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UseCases;